/**
 * Meses de periodo en los que el plan Premium puede estar activo (selector + persistencia en Redux).
 * Fuera de esta lista se deshabilita el card Premium y se limpia su selección al cambiar el periodo.
 */
export const PREMIUM_ALLOWED_SELECTED_MONTHS: readonly number[] = [3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const isPremiumMonthSelectionInvalid = (months: number | null): boolean =>
    months === null || !PREMIUM_ALLOWED_SELECTED_MONTHS.includes(months);
